import {
    GET_CARD_BRAND_DEF,
    GET_CARD_BRAND_DEF_SUCCESS,
    CARD_BRAND_DEF_API_ERROR
  } from "./actionTypes"
  
  export const getCardBrandDefList = () => ({
    type: GET_CARD_BRAND_DEF,
  })
  
  export const getCardBrandDefListSuccess = record => ({
    type: GET_CARD_BRAND_DEF_SUCCESS,
    payload: record,
  })

  export const cardBrandDefApiError = error => {
    return {
      type: CARD_BRAND_DEF_API_ERROR,
      payload: error,
    }
  }
  